import MiniHeaders from "./mini-headers";
import {topics} from "../data/mock-date";
import React from "react";


const CourseOutline = () => {
    return (
        <div>
            <div className={'blocks-wrapper'}>
                <MiniHeaders headerName={'Դասընթացի Ծրագիրը'}/>
                <ul className={'features'}>
                    {
                        topics.map((item, index) => {
                            return (
                                <li key={index} className={'list-item'}>
                                    <span>{index + 1}.</span>
                                    <p className={'li-item'}>{item}</p>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
        </div>
    );
};

export default CourseOutline;
